


import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import notificationSound from "../assets/notification.mp3";
 
// const BASE_URL = "http://88.99.5.236:5555/api";
const BASE_URL = "https://uptask.visiontrek.io/api";

 
export default function WorkingStatusModal() {
  const [showModal, setShowModal] = useState(false);
 
  // Helper to make API calls using the same logic as the rest of the application
  const makeRequest = async (endpoint, method = "GET") => {
    const token = Cookies.get("token");
    const res = await fetch(`${BASE_URL}${endpoint}`, {
      method,
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        "Content-Type": "application/json",
      },
    });
    return res.json();
  };
 
  // 🚀 STEP 2: SHOW MODAL AT 7:00
  // useEffect(() => {
  //   const now = new Date();
  //   const target = new Date();
  //   target.setHours(19, 0, 0, 0); // 7:00 PM
 
  //   const delay = target - now;
  //   if (delay > 0) {
  //     const timer = setTimeout(() => {
  //       setShowModal(true);
  //     }, delay);
  //     return () => clearTimeout(timer); // Cleanup
  //   }
  // }, []);

  useEffect(() => {
    let timer;
  
    const scheduleModal = async () => {
      const now = new Date();
      const currentHours = now.getHours();
      const currentMinutes = now.getMinutes();

      // Ensure we are inside the 7:00 PM to 7:30 PM window
      if (currentHours === 19 && currentMinutes >= 0 && currentMinutes < 30) {
        try {
          // ✅ CHECK STATUS BEFORE SHOWING
          const data = await makeRequest("/attendance/status", "GET");
  
          // Only show if they punched IN today, but haven't punched OUT
          if (data && data.punchedIn && !data.punchedOut) {
            setShowModal(true);
          } else {
            setShowModal(false);
          }
        } catch (err) {
          console.error(err);
        }
      }

      // Calculate next check time
      const target = new Date();
      if (currentHours === 19 && currentMinutes < 30) {
        // If we are currently inside the window, check again when the window ends (7:30 PM)
        target.setHours(19, 30, 0, 0);
      } else if (currentHours > 19 || (currentHours === 19 && currentMinutes >= 30)) {
        // If it's past 7:30 PM, schedule for tomorrow 7:00 PM
        target.setDate(target.getDate() + 1);
        target.setHours(19, 0, 0, 0);
      } else {
        // If it's before 7:00 PM today, schedule for today 7:00 PM
        target.setHours(19, 0, 0, 0);
      }
  
      const delay = target - new Date();
  
      timer = setTimeout(() => {
        scheduleModal(); // 🔁 reschedule and check again
      }, delay);
    };
  
    scheduleModal();
  
    return () => clearTimeout(timer);
  }, []);

  // 🚀 AUTO CLOSE MODAL AFTER 7:30 PM
  useEffect(() => {
    let interval;
    if (showModal) {
      interval = setInterval(() => {
        const now = new Date();
        // If it is past 7:30 PM, automatically hide the modal
        if (now.getHours() > 19 || (now.getHours() === 19 && now.getMinutes() >= 30)) {
          setShowModal(false);
        }
      }, 10000); // Check every 10 seconds
    }
    return () => clearInterval(interval);
  }, [showModal]);
 
  // 🚀 POLLING TO CLOSE IF PUNCHED OUT BY PHONE / OTHER TAB
  useEffect(() => {
    if (!showModal) return;
 
    const interval = setInterval(async () => {
      try {
        const data = await makeRequest("/attendance/status", "GET");
        if (data && data.punchedOut) {
          setShowModal(false);
        }
      } catch (error) {
        console.error("Error checking attendance status", error);
      }
    }, 5000);
 
    return () => clearInterval(interval);
  }, [showModal]);
 
  // 🎵 PLAY SOUND ON OPEN
  useEffect(() => {
    if (showModal) {
      const audio = new Audio(notificationSound);
      audio.volume = 0.7;
      audio.play().catch(console.error);
    }
  }, [showModal]);
 
  // 🚀 STEP 3: HANDLE BUTTONS
  const handleYes = async () => {
    try {
      await makeRequest("/attendance/still-working", "POST");
      setShowModal(false);
    } catch (error) {
      console.error(error);
    }
  };
 
  const handleNo = async () => {
    try {
      await makeRequest("/attendance/auto-punch-out", "POST");
      setShowModal(false);
    } catch (error) {
      console.error(error);
    }
  };
 
  // 🎨 STEP 6: MODAL UI
  if (!showModal) return null;
 
  return (
    <div className="fixed inset-0 z-[9999] bg-black/60 backdrop-blur-sm flex items-center justify-center px-4">
      <div className="bg-gradient-to-br from-[#2b1a63] to-[#160f3a] p-8 rounded-2xl shadow-2xl w-full max-w-md border border-white/10 text-white text-center">
 
        {/* Animated Clock Icon */}
        <div className="mx-auto mb-5 w-16 h-16 rounded-full bg-yellow-500/20 flex items-center justify-center">
          <span className="text-3xl animate-bounce">⏰</span>
        </div>
 
        <h3 className="text-xl font-bold mb-2">
          Are you still working?
        </h3>
 
        <p className="text-sm text-white/70 mb-6">
          It's past 7:00 PM. If you're done for the day, please punch out or confirm you are still working.
        </p>
 
        <div className="flex gap-3 justify-center">
          {/* YES — Still Working */}
          <button
            onClick={handleYes}
            className="px-5 py-2.5 bg-green-600 hover:bg-green-500 text-white rounded-xl font-semibold transition-all hover:scale-105 shadow-lg shadow-green-600/30"
          >
            ✅ Yes, I'm working
          </button>
 
          {/* NO — Punch me out */}
          <button
            onClick={handleNo}
            className="px-5 py-2.5 bg-red-600 hover:bg-red-500 text-white rounded-xl font-semibold transition-all hover:scale-105 shadow-lg shadow-red-600/30"
          >
            🚪 No, Punch out
          </button>
        </div>
      </div>
    </div>
  );
}
 





// import React, { useState, useEffect } from "react";
// import Cookies from "js-cookie";

// const BASE_URL = "http://192.168.1.16:5555/api";

// export default function WorkingStatusModal() {
//   const [showModal, setShowModal] = useState(false);

//   console.log("🟡 Component Rendered | showModal:", showModal);

//   // Helper API
//   const makeRequest = async (endpoint, method = "GET") => {
//     const token = Cookies.get("token");

//     console.log("🌐 API CALL:", {
//       url: `${BASE_URL}${endpoint}`,
//       method,
//       token,
//     });

//     try {
//       const res = await fetch(`${BASE_URL}${endpoint}`, {
//         method,
//         headers: {
//           Authorization: token ? `Bearer ${token}` : "",
//           "Content-Type": "application/json",
//         },
//       });

//       const data = await res.json();

//       console.log("✅ API RESPONSE:", data);

//       return data;
//     } catch (error) {
//       console.error("❌ API ERROR:", error);
//     }
//   };

//   // 🚀 STEP 2: SHOW MODAL AT 7:00
//   useEffect(() => {
//     const now = new Date();
//     const target = new Date();
//     target.setHours(19, 0, 0, 0);

//     const delay = target - now;

//     console.log("⏰ TIMER SET (OPEN MODAL)");
//     console.log("Current Time:", now.toLocaleTimeString());
//     console.log("Target Time (7 PM):", target.toLocaleTimeString());
//     console.log("Delay (ms):", delay);

//     if (delay > 0) {
//       const timer = setTimeout(() => {
//         console.log("🟢 SHOW MODAL TRIGGERED at:", new Date().toLocaleTimeString());
//         setShowModal(true);
//       }, delay);

//       return () => {
//         console.log("🧹 Clearing OPEN timer");
//         clearTimeout(timer);
//       };
//     } else {
//       console.log("⚠️ Already past 7 PM, modal won't auto open");
//     }
//   }, []);

//   // 🚀 STEP 4: AUTO CLOSE AT 7:30
//   useEffect(() => {
//     if (!showModal) return;

//     const now = new Date();
//     const end = new Date();
//     end.setHours(19, 30, 0, 0);

//     const delay = end - now;

//     console.log("⏰ TIMER SET (AUTO CLOSE)");
//     console.log("Current Time:", now.toLocaleTimeString());
//     console.log("End Time (7:30 PM):", end.toLocaleTimeString());
//     console.log("Delay (ms):", delay);

//     if (delay > 0) {
//       const timer = setTimeout(() => {
//         console.log("🔴 AUTO CLOSE MODAL at:", new Date().toLocaleTimeString());
//         setShowModal(false);
//       }, delay);

//       return () => {
//         console.log("🧹 Clearing CLOSE timer");
//         clearTimeout(timer);
//       };
//     } else {
//       console.log("⚠️ Already past 7:30 PM → closing modal immediately");
//       setShowModal(false);
//     }
//   }, [showModal]);

//   // 🚀 STEP 5: POLLING
//   useEffect(() => {
//     if (!showModal) return;

//     console.log("🔁 START POLLING (every 5s)");

//     const interval = setInterval(async () => {
//       console.log("🔄 Checking attendance status...");

//       try {
//         const data = await makeRequest("/attendance/status", "GET");

//         console.log("📊 Attendance Status:", data);

//         if (data && data.punchedOut) {
//           console.log("🛑 User already punched out → closing modal");
//           setShowModal(false);
//         }
//       } catch (error) {
//         console.error("❌ Error checking attendance status", error);
//       }
//     }, 5000);

//     return () => {
//       console.log("🧹 STOP POLLING");
//       clearInterval(interval);
//     };
//   }, [showModal]);

//   // 🚀 BUTTON HANDLERS
//   const handleYes = async () => {
//     console.log("🟢 YES CLICKED");

//     try {
//       await makeRequest("/attendance/still-working", "POST");
//       console.log("✅ Still working API success");
//       setShowModal(false);
//     } catch (error) {
//       console.error("❌ Error on YES", error);
//     }
//   };

//   const handleNo = async () => {
//     console.log("🔴 NO CLICKED");

//     try {
//       await makeRequest("/attendance/auto-punch-out", "POST");
//       console.log("✅ Auto punch-out success");
//       setShowModal(false);
//     } catch (error) {
//       console.error("❌ Error on NO", error);
//     }
//   };

//   // 🎨 UI
//   if (!showModal) {
//     console.log("⚪ Modal Hidden");
//     return null;
//   }

//   console.log("🟣 Modal Visible");

//   return (
//     <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999]">
//       <div className="bg-white p-6 rounded-xl shadow-lg text-center w-80">
//         <h2 className="text-xl font-semibold mb-6 text-gray-800">
//           Are you still working?
//         </h2>
//         <div className="flex justify-center gap-4 text-sm font-medium">
//           <button
//             onClick={handleYes}
//             className="bg-green-500 hover:bg-green-600 transition-colors text-white px-6 py-2 rounded-lg"
//           >
//             Yes
//           </button>
//           <button
//             onClick={handleNo}
//             className="bg-red-500 hover:bg-red-600 transition-colors text-white px-6 py-2 rounded-lg"
//           >
//             No
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }




